<template>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
        >
        </avue-crud>
</template>
<script>
  import base from './Base'
  export default {
    name: 'curd',
    mixins: [base]
  }
</script>
